module.exports = __webpack_public_path__ + "static/img/khal_bj.91ad6ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/khal_bj.png
// module id = OaxG
// module chunks = 2